import CONSTANTS from '@/constants'

const isNavItemVisible = (item, context) => {
  const { featureFlags = {}, userRoles = [] } = context
  if (item.featureFlag && !featureFlags[item.featureFlag]) return false

  if (Array.isArray(item.requiredRoles) && item.requiredRoles.length) {
    const hasRequiredRole = item.requiredRoles.some(role => userRoles.includes(role))
    if (!hasRequiredRole) return false
  }

  return true
}

const routeExists = (routes = [], routeName = '') => {
  for (let index = 0; index < routes.length; index += 1) {
    const route = routes[index]
    if (route && route.name === routeName) return true
    if (route && Array.isArray(route.children) && routeExists(route.children, routeName)) {
      return true
    }
  }
  return false
}

export const resolveEditPathByType = (typeSelected, router) => {
  const routeName = CONSTANTS.EDIT_ROUTE_BY_TYPE[typeSelected] || ''
  if (!routeName) return ''
  if (!router || !router.options || !Array.isArray(router.options.routes)) {
    return routeName
  }
  return routeExists(router.options.routes, routeName) ? routeName : ''
}

export const filterNavMenuItems = (items = [], context = {}) => {

  return items
    .map(item => {
      if (item.header && Array.isArray(item.items)) {
        const filteredItems = filterNavMenuItems(item.items, context)
        if (!filteredItems.length) return null
        return { ...item, items: filteredItems }
      }

      if (item.submenu) {
        if (!isNavItemVisible(item, context)) return null
        const filteredSubmenu = filterNavMenuItems(item.submenu, context)
        if (!filteredSubmenu.length) return null
        return { ...item, submenu: filteredSubmenu }
      }

      return isNavItemVisible(item, context) ? item : null
    })
    .filter(Boolean)
}

export const buildLearningPathUrlById = (learningPathId) => {
  if (!learningPathId) return ''

  return `${process.env.VUE_APP_MY_INE_URL}/path/${learningPathId}`
}

export const buildLearningPathUrl = (learningPaths) => {
  const firstLearningPath = Array.isArray(learningPaths) && learningPaths.length
    ? learningPaths[0]
    : null

  if (
    firstLearningPath &&
    typeof firstLearningPath === 'object' &&
    firstLearningPath.id
  ) {
    return buildLearningPathUrlById(firstLearningPath.id)
  }

  return ''
}
